module.exports = __webpack_public_path__ + "static/media/cart-icon-svg.ec93a77e.svg";